import {isArray,isObject} from "my-tools-kit";

/**
 * 重新设置首页热门国家的起运城市参数：当后台设置了热门国家的默认起运城市时，需要将默认设置的起运城市参数覆盖当前展示的最低报价起运城市参数
 */
export function resetHotCountryStartCity(item){
  if(isObject(item)){
    let {
      // 国家默认起运城市id
      defaultCityId,
      // 国家默认起运城市代码
      defaultCityCode,
      // 国家默认起运城市名称
      defaultCityName,
    } = item;
    if(defaultCityId) {
      item = JSON.parse(JSON.stringify(item));
      item.fromCityInfo = {
        "id": defaultCityId,
        "value": defaultCityId,
        "code": defaultCityCode,
        "namec": defaultCityName,
        "namee": "",
        // 省名称
        "provinceName": "",
        "fkcode": "",
        "children": null,
      }
      if (isArray(item.fromSelectId)) {
        // [省id,城市id]
        item.fromSelectId = [null,defaultCityId];
      }
    }
  }
  return item;
}



// WEBPACK FOOTER //
// ./src/components/placeOrder/utils.home.js